import { MessageCircle } from "lucide-react";

/**
 * Remplace l'ancien bandeau de réassurance (TrustBar). Objectif : parler au syndic
 * bénévole avec ses mots, sur une vraie douleur du quotidien, avant de basculer sur
 * la promesse produit. Ton volontairement proche mais on garde le vouvoiement du reste
 * du site. Charte graphique TyCopro : Sulphur Point + palette indigo + motif discret.
 */
export default function PitchHook() {
    return (
        <section aria-labelledby="pitch-hook-title" className="relative isolate overflow-hidden bg-white">
            <div className="absolute inset-0 -z-10 pointer-events-none">
                <div className="absolute inset-0 bg-gradient-to-b from-primary-50/80 via-white to-white" />
                <div className="absolute left-1/2 top-4 -translate-x-1/2 w-[64rem] h-[26rem] rounded-full bg-primary-200/30 blur-3xl" />
                <div className="absolute inset-0 bg-dots-indigo opacity-[0.14] [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]" />
            </div>

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 text-center">
                <span className="animate-fade-in inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-white px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-primary-700 shadow-sm">
                    <MessageCircle className="w-3.5 h-3.5" />
                    Entre nous
                </span>

                <h2
                    id="pitch-hook-title"
                    className="animate-fade-in-up mt-7 font-heading text-3xl sm:text-4xl lg:text-[3.25rem] font-semibold tracking-[-0.03em] leading-[1.08] text-slate-900"
                >
                    Marre de courir après{" "}
                    <span className="relative inline-block">
                        <span className="relative z-10 bg-gradient-to-br from-primary-700 via-primary-600 to-primary-500 bg-clip-text text-transparent">
                            les charges impayées
                        </span>
                        <span className="absolute -bottom-1 left-0 right-0 h-3.5 bg-primary-200/70 -z-0 rounded" />
                    </span>{" "}
                    de votre voisin de palier ?
                </h2>

                <p
                    className="animate-fade-in-up mt-7 max-w-2xl mx-auto text-slate-600 text-lg sm:text-xl leading-relaxed"
                    style={{ animationDelay: "80ms" }}
                >
                    Relances qui traînent, AG à préparer seul, comptes qui ne tombent jamais juste…
                    On connaît la corvée.{" "}
                    <span className="font-semibold text-slate-900">TyCopro s'en charge à votre place</span> : vous,
                    vous gardez juste le contrôle.
                </p>
            </div>
        </section>
    );
}
